import React from 'react';
import * as Icons from 'lucide-react';
import { features } from '../mock';

const Features = () => {
  return (
    <section id="ecosystem" className="px-4 md:px-10 py-20">
      <div className="mx-auto max-w-[1240px]">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full border border-emerald-700/30 bg-emerald-100 px-3.5 py-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-emerald-800">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" /> Why SkyWay Green
            </div>
            <h2 className="mt-4 font-serif text-emerald-950 text-4xl md:text-5xl leading-[1.05] tracking-tight max-w-2xl">
              A vertically integrated <span className="italic text-emerald-600">green</span> transport ecosystem.
            </h2>
          </div>
          <p className="text-emerald-900/70 max-w-md text-[15px] leading-relaxed">
            Six core capabilities that make our elevated string network the most efficient urban mobility platform ever engineered.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {features.map((f) => {
            const Icon = Icons[f.icon] || Icons.Circle;
            return (
              <div
                key={f.id}
                className="group relative rounded-2xl border border-emerald-900/60 bg-gradient-to-b from-[#0a1e14] to-[#061810] p-6 hover:border-emerald-700/70 transition"
              >
                <div className="h-11 w-11 rounded-xl bg-emerald-500/15 border border-emerald-800/70 flex items-center justify-center text-emerald-300 group-hover:bg-emerald-500/25 transition">
                  <Icon size={20} />
                </div>
                <h3 className="mt-5 text-white text-lg font-medium">{f.title}</h3>
                <p className="mt-2 text-[14px] text-emerald-100/65 leading-relaxed">{f.description}</p>
                <div className="mt-5 h-px w-full bg-gradient-to-r from-emerald-800/60 via-emerald-700/20 to-transparent" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
